module.exports = __webpack_public_path__ + "fonts/Sofort.b3201f9ecd61833ab96680c6f0853f89.svg";